<template>
  <div class="charge-warp">
    <div class="display-f just-b align-i-c">
      <el-form ref="form" :model="searchForm" inline>
        <el-form-item>
          <el-date-picker
            v-model="searchForm.date"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :editable="false"
            :clearable="false"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="执行人" v-model="searchForm.executeName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.isGroupOrder" placeholder="订单类型" clearable>
            <el-option label="普通订单" :value="0"></el-option>
            <el-option label="团购订单" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.isRevoke" placeholder="是否撤销执行" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="searchForm.revokeDate"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="撤销开始日期"
            end-placeholder="撤销结束日期"
            :editable="false"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <custom-button type="primary" @click="handleSearch">查询</custom-button>
          <custom-button type="" @click="handleReset">重置</custom-button>
        </el-form-item>
      </el-form>
      <custom-button type="primary" plain @click="handleExport">导出</custom-button>

    </div>
    <div class="table-warp">
      <customTable
        :cell-style="{ borderColor: '#DDDDDD' }"
        height="600"
        tooltip-effect="dark"
        :currentPage="searchForm.currentPage"
        :currentPageSize="searchForm.pageSize"
        :total="total"
        :tableData="tableData"
        :column="column"
        :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }"
        border
        @pageChange="pageChange">
        <div slot="other">金额合计：{{ totalData }}</div>
      </customTable>
    </div>
  </div>
</template>

<script>
import customTable from '@/components/customTable/customTable'
import { statementDTO, CommonDTO } from '@/DTO/index'
import { Utils } from '@/utils/utils'
import moment from 'moment';
import { isMoreThanOneYear, isNull, debounce } from '@/utils/validateBase'
export default {
  // 定义引入的组件
  components: { customTable },
  props: {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨日',
          onClick(picker) {
            let yesterday = moment().subtract(1, 'days')
            const end = Utils.timeFormat(Number(Utils.endOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '本周',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '本月',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('month'))), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('month'))), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '本年',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('year'))), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('year'))), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        },
        ]
      },
      searchForm: {
        date: [],
        executeName: '',
        isGroupOrder: '',
        isRevoke: '',
        revokeDate: [],
        currentPage: 1,
        pageSize: 20,
        deptId: this.$session.get('deptId'),
      },//搜索条件
      tableData: [],//表格数据
      total: 0,//总数
      totalData: 0,//金额合计
    }
  },
  computed: {
    column() {
      // 表头
      const columns = [
        { label: "执行人", prop: "executeName", width: 150, align: 'left' },
        { label: "执行日期", prop: "executeDate", width: 200, align: 'left', showOverflowTooltip: true },
        { label: "是否撤销执行", prop: 'isRevoke', width: 120, align: 'center', formatter: (row => {
            return row.isRevoke ? '是' : '否'
          })
        },
        { label: "撤销时间", prop: "revokeTime", width: 200, align: 'center' },
        { label: "撤销人", prop: "revokeUserName", width: 120, align: 'center' },
        { label: "执行项目", prop: "physioName", width: 200, align: 'left' },
        { label: "单价", prop: "price", width: 104, align: 'right' },
        { label: "次数", prop: "executeNum", width: 76, align: 'left' },
        { label: "金额合计", prop: "originTotalPrice", width: 100, align: 'right', },

        { label: "议价", prop: "bargainDiscountAmount", width: 124, align: 'center', },
        { label: "优惠券", prop: "couponDiscountAmount", width: 124, align: 'center', },
        { label: "至尊卡", prop: "vipCardDiscountAmount", width: 124, align: 'center', },
        { label: "美团商家优惠", prop: "meituanMerchantDiscountAmount", width: 124, align: 'center', },

        { label: "实收", prop: "totalPrice", width: 124, align: 'right', },
        { label: "是否医保支付", prop: "ybPay", width: 120, align: 'left' },
        { label: "患者", prop: "patientName", width: 100, align: 'left' },
        {
          label: "性别", prop: "sex", width: 70, align: 'left', formatter: (row => {
            return row.sex == '1' ? '女' : '男'
          })
        },
        { label: "年龄", prop: "age", width: 70, align: 'left' },
        { label: "手机号码", prop: "phone", width: 126, align: 'left' },
        { label: "开单人", prop: "saleName", width: 92, align: 'left' },
        { label: "开单时间", prop: "saleDate", width: 110, align: 'left', showOverflowTooltip: true },
        { label: "支付时间", prop: "payDate", width: 160, align: 'left', showOverflowTooltip: true },
        { label: "执行医馆", prop: "deptName", width: 100, align: 'left' },
        { label: "销售医馆", prop: "commissionDeptName", width: 100, align: 'left' },
        { label: "订单类型", prop: "isGroupOrder", width: 100 }
      ]
      // const deptId = this.$session.get('deptId')
      // if (deptId != 0) {
      //   // 分管
      //   return columns.filter(item => item.prop != 'deptName' || item.prop != 'commissionDeptName')
      // }
      return columns
    }
  },
  //变量监听
  watch: {},
  // 页面初始化
  created() {
    let time = CommonDTO.getSystemTimeDTO()
    let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
    let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
    this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
    this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
    this.getExecuteIncome()
    this.getExecuteIncomeCount()
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
     * 页码改变
     */
    pageChange(obj) {
      let { current, size } = obj
      this.searchForm.currentPage = current
      this.searchForm.pageSize = size
      this.getExecuteIncome()
      this.getExecuteIncomeCount()
    },
    /**
     * 重置
     */
    handleReset() {
      this.searchForm = {
        date: [],
        searchValue: '',
        isGroupOrder: '',
        isRevoke: '',
        revokeDate: [],
        currentPage: 1,
        pageSize: 20,
        deptId: this.$session.get('deptId'),
      }

      this.searchForm.date[0] = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('month'))), 'yyyy-MM-DD HH:mm:ss')
      this.searchForm.date[1] = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('month'))), 'yyyy-MM-DD HH:mm:ss')

      this.getExecuteIncome()
      this.getExecuteIncomeCount()
    },

    /**
     * 搜索
     */
    handleSearch() {
      this.searchForm.currentPage = 1
      let flag = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 366)
      if (flag) return this.$message.error('时间范围不能超过一年')
      // let HH = this.$moment().get('hour')
      // let flagOneDay = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 1)
      // if(flagOneDay && HH < 22 && HH > 7 ) return this.$message.error('当前选择的日期范围大于1天，请22:00后查询')
      this.getExecuteIncome()
      this.getExecuteIncomeCount()
    },

    /**
     * 查询执行业绩
     */
    async getExecuteIncome() {
      this.searchForm.startDate = Utils.startOfDay(this.searchForm.date[0])
      this.searchForm.endDate = Utils.endOfDay(this.searchForm.date[1])

      this.searchForm.revokeStartDate = (this.searchForm.revokeDate && this.searchForm.revokeDate[0]) && Utils.startOfDay(this.searchForm.revokeDate[0]) || ''
      this.searchForm.revokeEndDate = (this.searchForm.revokeDate && this.searchForm.revokeDate[1]) && Utils.endOfDay(this.searchForm.revokeDate[1]) || ''
      
      let { code, rows, total } = await statementDTO.getExecuteIncome({
        ...this.searchForm,
        deptId: [0,-1].includes(this.searchForm.deptId) ? '' : this.searchForm.deptId
      })
      if (code == 200) {
        this.tableData = rows
        this.total = total
      }
    },

    /**
     * 查询执行业绩统计
     */
    async getExecuteIncomeCount() {
      this.searchForm.startDate = Utils.startOfDay(this.searchForm.date[0])
      this.searchForm.endDate = Utils.endOfDay(this.searchForm.date[1])

      this.searchForm.revokeStartDate = (this.searchForm.revokeDate && this.searchForm.revokeDate[0]) && Utils.startOfDay(this.searchForm.revokeDate[0]) || ''
      this.searchForm.revokeEndDate = (this.searchForm.revokeDate && this.searchForm.revokeDate[1]) && Utils.endOfDay(this.searchForm.revokeDate[1]) || ''
      let { code, data } = await statementDTO.getExecuteIncomeCount({
        ...this.searchForm,
        deptId: [0,-1].includes(this.searchForm.deptId) ? '' : this.searchForm.deptId
      })
      if (code == 200) {
        this.totalData = isNull(data.money) ? 0 : data.money
      }
    },
    /**
    * 导出
    */
    handleExport: debounce(function () {
      this.searchForm.startDate = Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
      this.searchForm.endDate = Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')

      this.searchForm.revokeStartDate = (this.searchForm.revokeDate && this.searchForm.revokeDate[0]) && Utils.timeFormat(this.searchForm.revokeDate[0], 'yyyy-MM-DD HH:mm:ss') || ''
      this.searchForm.revokeEndDate = (this.searchForm.revokeDate && this.searchForm.revokeDate[1]) && Utils.timeFormat(this.searchForm.revokeDate[1], 'yyyy-MM-DD HH:mm:ss') || ''
      statementDTO.executeIncomeExport({
        ...this.searchForm,
        deptId: [0,-1].includes(this.searchForm.deptId) ? '' : this.searchForm.deptId
      }, { name: '执行业绩' }).then(res => { })
    }, 1000, true),

  },
}
</script>
<style lang="less" scoped>
.charge-warp {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .el-form-item {
    margin-bottom: 0;
  }

  .table-warp {
    margin-top: 16px;
    flex: 1;

    /deep/.el-table {
      border-color: #DDDDDD;
    }

    /deep/.pagination-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 0;

      .total-tips {
        color: #667182;
        font-size: 14px;
      }
    }
  }
}
</style>